const menuList = [
    {
        name: "首页",
        url: "/",
        iconPath: '/img/menu/home.png',
        selectedIconPath: '/img/menu/home-active.png',
    },
    {
        name: "节目管理",
        iconPath: '/img/menu/program.png',
        selectedIconPath: '/img/menu/program-active.png',
        children: [
            {
                name: "节目列表",
                url: '/program'
            },
            {
                name: "素材库",
                url: "/material/manage"
            }
        ]
    },
    {
        name: "终端管理",
        iconPath: '/img/menu/device.png',
        selectedIconPath: '/img/menu/device-active.png',
        children: [{
            name: "终端列表",
            url: "/device",
        },
        {
            name: "APK管理",
            url: "/device/apk",
        },
        ]
    },
    {
        name: "报表统计",
        iconPath: '/img/menu/data.png',
        selectedIconPath: '/img/menu/data-active.png',
        children: [{
            name: "在线统计",
            url: "/device/state/statistic",
        },
        {
            name: "设备状态",
            url: "/device/state/list",
        },
        {
            name: "播放日志",
            url: "/device/play/log",
        }
        ]
    },
    {
        name: "系统设置",
        iconPath: '/img/menu/setting.png',
        selectedIconPath: '/img/menu/setting-active.png',
        children: [{
            name: "部门列表",
            url: "/system/department"
        },
        {
            name: "角色列表",
            url: "/system/role"
        },
        {
            name: "基础设置",
            url: "/system/set"
        },
        {
            name: "操作日志",
            url: "/system/operation"
        },
        {
            name: "门店列表",
            url: "/system/store"
        },
        {
            name: "用户列表",
            url: "/system/user"
        },
        {
            name: "菜单管理",
            url: "/system/module"
        }
        ]
    },
]

// 自动增加ID
let index = 1;
function each(data) {
    data.map((v) => {
        v.id = index++;
        v.open = false;
        v.active = false;

        if (v.children) {
            v.children = each(v.children)
        }

        return v;
    })

    return data;
}


each(menuList);

export default menuList;
